import { type MCPServerInfo } from '../../types';

const BigQueryRemoteServer: MCPServerInfo = {
  serverId: 'BIGQUERY_REMOTE',
  name: 'BigQuery',
  slug: 'bigquery-remote',
  description: 'Google BigQuery remote MCP Server',
  source: {
    sourceType: 'REMOTE_URL',
    mcpServerUrl: 'https://bigquery.googleapis.com/mcp',
    transport: 'STREAMABLE_HTTP'
  },
  authenticationType: 'OAUTH',
  serverConfig: {
    required: [],
    properties: {}
  },
  installConfig: {
    required: [],
    properties: {}
  },
  annotations: {
    hintPreRegistered: true
  }
};

export default BigQueryRemoteServer;
